import React, { useEffect } from "react";
import useOnlineStatus from "../../../../hooks/useOnlineStatus";
import * as styles from "./OfflineIndicator.module.css";

export default function OfflineIndicator({ wsOnline }) {
  const isOnline = useOnlineStatus(wsOnline);
  const className = `${styles.banner} ${isOnline ? "" : styles.visible}`.trim();

  useEffect(() => {
    try {
      if (!isOnline) document.body.classList.add("offline-banner-visible");
      else document.body.classList.remove("offline-banner-visible");
    } catch (e) {
  
        console.error("OfflineIndicator: failed to toggle body class", e);
    }

    try {
      window.dispatchEvent(
        new CustomEvent("offlineBanner", { detail: { visible: !isOnline } })
      );
    } catch (e) {
      try {
        console.error("OfflineIndicator: failed to dispatch offlineBanner event", e);
      } catch (_err) {}
    }

    return () => {
      try {
        document.body.classList.remove("offline-banner-visible");
      } catch (e) {
        try {
          console.error("OfflineIndicator: failed to remove body class during cleanup", e);
        } catch (_err) {}
      }

      try {
        window.dispatchEvent(
          new CustomEvent("offlineBanner", { detail: { visible: false } })
        );
      } catch (e) {
        try {
          console.error("OfflineIndicator: failed to dispatch offlineBanner cleanup event", e);
        } catch (_err) {}
      }
    };
  }, [isOnline]);

  return (
    <div
      className={className}
      role="status"
      aria-live="polite"
      aria-hidden={isOnline}
    >
      <span className={styles.bannerText}>You are offline</span>
    </div>
  );
}

